<template>
  <div>

    <loading v-show="showLoading"></loading>

    <div class="after-logistics-back"  v-show="!showLoading" >

      <div class="after-logistics">

        <div class="after-logistics-desc">
          *商家已同意您的退货申请，请在7天内寄出商品并提供
          物流信息，过期将自动取消申请
          <div class="after-logistics-party party-margin">
            <div class="after-logistics-party-title">
              收件人
            </div>
            <div class="after-logistics-party-value">
              杭州Hello Kitty乐园
            </div>
          </div>
          <div class="after-logistics-party">
            <div class="after-logistics-party-title">
              地   址
            </div>
            <div class="after-logistics-party-value">
              浙江省安吉县天使大道1号
            </div>
          </div>
          <div class="after-logistics-party">
            <div class="after-logistics-party-title">
              电   话
            </div>
            <div class="after-logistics-party-value">
              4009-778899
            </div>
          </div>
        </div>

        <div class="after-logistics-each after-logistics-height">
          <div class="after-logistics-each-left">
            申请时间
          </div>
          <div class="after-logistics-each-right">
            {{afterDetail.date|formatDate}}
          </div>
        </div>

        <div class="after-logistics-each after-logistics-height">
          <div class="after-logistics-each-left">
            售后编号
          </div>
          <div class="after-logistics-each-right">
            {{afterDetail.code}}
          </div>
        </div>

        <div class="after-logistics-each after-logistics-height">
          <div class="after-logistics-each-left">
            售后类型
          </div>
          <div class="after-logistics-each-right" v-if="afterDetail.typeId==1">
            退款
          </div>
          <div class="after-logistics-each-right" v-if="afterDetail.typeId==0">
            退货退款
          </div>
        </div>

        <div class="after-logistics-each after-logistics-height">
          <div class="after-logistics-each-left">
            订单编号
          </div>
          <div class="after-logistics-each-right">
            {{afterDetail.orderId}}
          </div>
        </div>

      </div>

      <div class="after-logistics-reason">
        <div class="after-logistics-div head-bold">
          物流信息填写
        </div>
        <div class="after-logistics-div">
          <div class="after-logistics-div-title">
            退货方式
          </div>
          <div class="after-logistics-div-value">
            <div class="after-logistics-type" @click="choiceType(0)">
              <img src="@/images/icon_Selected@3x.png" class="type-img" v-if="logisticsType==0"/>
              <img src="@/images/icon_Unselected@3x.png" class="type-img" v-if="logisticsType==1"/>
              快递
            </div>
          </div>
        </div>
        <div class="after-logistics-div margin-bottom" v-if="logisticsType==0">
          <div class="after-logistics-div-title">
            物流公司
          </div>
          <div class="after-logistics-div-value">
            <select class="after-select"  v-model="selected">
              <option v-for="(logistics,index) in logisticsList" :key="index" v-bind:value="logistics.partyId">{{logistics.shipmentMethodTypeId}}</option>
            </select>
          </div>
        </div>
        <div class="after-logistics-div" v-if="logisticsType==0">
          <div class="after-logistics-div-title">
            快递单号
          </div>
          <div class="after-logistics-div-value">
            <input type="text" placeholder="请输入快递单号" class="logistics-input zt12" v-model="logisticsNo">
          </div>
        </div>
      </div>

      <div class="after-logistics-button">
        <button @click="commitLog()">
          提交
        </button>
      </div>


    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { storeName,prodCatalogId,loginInfo } from '@/router/Constant'
  import {afterCancel,login,getAfterSaleDetail,getCarrierShipmentMethod,getAfterSaleLogistics} from '@/router/api'
  import { NavBar, Image, Grid, Tabbar, Toast,PullRefresh,Dialog} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';
  import refresh from '@/components/page/common/refresh.vue';
  export default {
    name: "afterLogistics",
    data(){
      return{
        showLoading:true,
        token:getStore('externalLoginKey'),
        afterDetail:{},
        productStoreId:storeName,
        returnId:this.$route.query.returnId,
        logisticsType:0,
        logisticsList:[],
        logisticsNo:'',
        selected:'',
      }
    },

    mounted(){
      this.initData()
      // 检测浏览器变化
      let self = this;
      window.onresize = function() {
        return (function(){
          self.screenHeight = document.documentElement.clientHeight;
        })()
      }
    },
    components:{
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      [PullRefresh.name]: PullRefresh,
      loading,
      refresh,
      [Dialog.Component.name]: Dialog.Component,
    },

    filters: {
      formatDate: function (value) {
        if(value!=null&&value!=''&&value!=undefined ){
          let date = new Date(value)
          let y = date.getFullYear()
          let MM = date.getMonth() + 1
          MM = MM < 10 ? ('0' + MM) : MM
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          let h = date.getHours();
          h = h < 10 ? ('0' + h) : h;
          let m = date.getMinutes();
          m = m < 10 ? ('0' + m) : m;
          let s = date.getSeconds();
          s = s < 10 ? ('0' + s) : s;
          return y + '-' + MM + '-' + d + ' ' + h + '-' + m + '-' + s + ''
        }else{
          return ''
        }

      }
    },

    methods: {

      async initData() {
        this.getAfterDetail()
        this.getLogisticsList()
      },

      //获取详情
      getAfterDetail: function () {
        let params = {
          externalLoginKey: this.token,
          code: this.returnId,
        }
        getAfterSaleDetail(params)
          .then(res => {
            this.showLoading = false
            console.log(res);
            if (!res._ERROR_MESSAGE_) {
              this.afterDetail = res
              this.selected = res.shipCompany
              this.logisticsNo = res.shipCode
            } else {
              Toast({message:res._ERROR_MESSAGE_})
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      //获取物流公司列表
      getLogisticsList:function(){
        getCarrierShipmentMethod()
          .then(res => {
            this.showLoading = false
            console.log(res);
            if (!res._ERROR_MESSAGE_) {
              res.carrierShipmentMethod.splice(0,0,{partyId:'',shipmentMethodTypeId:'请选择'})
              this.logisticsList = res.carrierShipmentMethod
            } else {
              Toast({message:res._ERROR_MESSAGE_})
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      //选择配送方式
      choiceType:function (type) {
        if(type==0){
          //物流公司
          this.logisticsType = 0
        }else{
          this.logisticsType = 1
        }
      },

      //提交物流信息
      commitLog:function () {
        let params = {
          externalLoginKey: this.token,
          code: this.returnId,
          logisticsTypeId:this.logisticsType,
          logisticsId:this.selected,
          logisticsNo:this.logisticsNo
        }
        getAfterSaleLogistics(params)
          .then(res => {
            this.showLoading = false
            console.log(res);
            if (!res._ERROR_MESSAGE_) {
              Toast({message:'提交成功'})
              this.$router.back(-1)
            } else {
              Toast({message:res._ERROR_MESSAGE_})
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
  }
</script>

<style>
  .after-logistics{
    width:100%;
  }
  .after-logistics-each{
    width:100%;
  }
  .after-logistics-desc{
    line-height: 1.25rem;
    border-bottom: 1px solid #eee;
    color:#EB84AB;
    font-size: 0.875rem;
    padding: 1rem;
    font-weight: bold;
  }
  .party-margin{
    margin-top: 0.5rem;
  }
  .after-logistics-party{
    width:100%;
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: 0.75rem;
    color:#EB84AB;
  }
  .after-logistics-party-title{
    display: inline-block;
    vertical-align: top;
    width:3rem;
  }
  .after-logistics-party-value{
    display: inline-block;
    vertical-align: top;
  }
  .after-logistics-height{
    height: 3.4375rem;
    line-height: 3.4375rem;
    border-bottom: 1px solid #eee;
  }
  .after-logistics-each-left{
    display: inline-block;
    vertical-align: top;
    color:#333312;
    font-size: 0.8125rem;
    width:4.5rem;
    margin-left: 1rem;
    text-align: left;
  }
  .after-logistics-each-right{
    display: inline-block;
    vertical-align: top;
    color:#666666;
    margin-right: 1rem;
    font-size: 0.75rem;
  }
  .after-logistics-reason{
    width:100%;
    padding-bottom: 5rem;
  }
  .after-logistics-div{
    width:21.4375rem;
    margin: 0 auto;
    height: 3rem;
    line-height: 3rem;
  }
  .head-bold{
    font-weight: bold;
    color:#333;
    font-size: 0.8125rem;
  }
  .after-logistics-div-title{
    width:4.5rem;
    display: inline-block;
    vertical-align: top;
    color:#333;
    font-size: 0.8125rem;
  }
  .after-logistics-div-value{
    display: inline-block;
    vertical-align: top;
  }
  .logistics-input{
    line-height: 1.5rem;
    height:1.5rem;
    padding-left: 1rem;
    border: 1px solid #eaeaea;
    width: 13.3rem;
    margin-right: 1rem;
    border-radius: 1rem;
  }

  .logistics-input::-webkit-input-placeholder{
    line-height: normal ;
    padding-top: 3px;
  }


  .after-logistics-type{
    display: inline-block;
    vertical-align: top;
    font-size: 0.875rem;
    color:#333;
    height: 3rem;
    line-height: 3rem;
    margin-right: 0.5rem;
  }
  .type-img{
    width:1.0625rem;
    height: 1.0625rem;
    position: relative;
    top: 0.2rem;
  }
  .after-select{
    width:15.625rem;
    height: 2rem;
    border: 1px solid #eee;
    border-radius: 0.5rem;
    background-color: white;
    color:#333;
    font-size: 0.8125rem;
  }
  .margin-bottom{
    margin-bottom: 1rem;
  }
  .after-logistics-button{
    width:100%;
    height: 4rem;
    position: fixed;
    bottom: 0;
  }
  .after-logistics-button button{
    width:19.375rem;
    height: 2.75rem;
    line-height: 2.75rem;
    color:white;
    font-size: 1rem;
    text-align: center;
    margin: 0.5rem 1.5rem;
    background-color: #EB84AB;
    border-radius: 1.375rem;
    padding: 0;
  }



</style>



// WEBPACK FOOTER //
// src/components/page/after/afterLogistics.vue